export enum ComplianceRoutes {
  root = 'organization/compliance',
}
